import React from "react";
import { motion } from "framer-motion";
import { Quote, BookOpen, CreditCard, Plane, Bus } from "lucide-react";
import { LANDING } from "@/constants/testIds";

const QUOTES = [
  {
    icon: BookOpen,
    tag: "Education fee",
    name: "Anjali R.",
    role: "Parent · Pune",
    text: "Paid my daughter's professional language training fees through EMDpay. The educator got the money cleanly to their bank — and we earned reward points on the way.",
  },
  {
    icon: CreditCard,
    tag: "Credit card",
    name: "Rohan M.",
    role: "Software Engineer · Bengaluru",
    text: "Compared 100+ cards inside the app, picked one matching my spends and got approved in a day. The ₹500 Amazon voucher on apply was a nice surprise.",
  },
  {
    icon: Plane,
    tag: "Flights",
    name: "Sneha V.",
    role: "Frequent flyer · Hyderabad",
    text: "I price-checked DEL–BOM across three apps and EMDpay had the cheapest one-way fare — student discount applied without any drama.",
  },
  {
    icon: Bus,
    tag: "Hotels & Bus",
    name: "Vikram S.",
    role: "Architect · Mumbai",
    text: "Booked a hotel and a Volvo bus for a site visit in two minutes. The booking flow is genuinely clean — no upsells, no confusing screens.",
  },
];

export const Testimonials = () => {
  return (
    <section
      data-testid={LANDING.testimonialsSection}
      className="relative py-24 md:py-32"
    >
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <div className="max-w-3xl">
          <p className="text-[11px] uppercase tracking-[0.22em] font-semibold text-[#F25C2A]">
            · Loved across categories
          </p>
          <h2 className="mt-4 font-serif text-4xl sm:text-5xl tracking-tight leading-[1.05] text-[#0A0A0A]">
            One marketplace, <em className="italic text-[#F25C2A] font-normal">many wins</em>.
          </h2>
        </div>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-2 gap-5">
          {QUOTES.map((q, i) => (
            <motion.figure
              key={q.name}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.07, duration: 0.5 }}
              className="relative bg-white border border-[#E5E5E0] rounded-3xl p-8 sm:p-10"
            >
              <Quote
                size={36}
                className="text-[#F25C2A]/30 absolute top-6 right-6"
              />
              <div className="inline-flex items-center gap-2 rounded-full bg-[#FEF0EB] text-[#F25C2A] px-3 py-1 text-[11px] uppercase tracking-[0.18em] font-semibold">
                <q.icon size={12} />
                {q.tag}
              </div>
              <blockquote className="mt-5 font-serif text-xl sm:text-2xl leading-snug text-[#0A0A0A] max-w-prose">
                &ldquo;{q.text}&rdquo;
              </blockquote>
              <figcaption className="mt-7 flex items-center gap-3">
                <span className="h-10 w-10 rounded-full bg-[#FEF0EB] text-[#F25C2A] font-semibold flex items-center justify-center">
                  {q.name[0]}
                </span>
                <div>
                  <p className="text-sm font-semibold text-[#0A0A0A]">{q.name}</p>
                  <p className="text-xs text-[#737373]">{q.role}</p>
                </div>
              </figcaption>
            </motion.figure>
          ))}
        </div>
      </div>
    </section>
  );
};
